import { render } from "./Menus.vue?vue&type=template&id=74bb3588&scoped=true"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"

import "./Menus.vue?vue&type=style&index=0&id=74bb3588&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bb3588"]])

export default __exports__